// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#afis-app .app {
  margin-bottom: 35px;
}
#afis-app .app-title {
  color: #333;
  display: inline-block;
  font-size: 18px;
  font-weight: 500;
  margin: 13px 0px 20px 0px;
  font-family: "Avenir Next LT W01 Demi", Arial;
}
#afis-app a {
  color: #1d5799;
}
#afis-app .shim-bottom-10 {
  margin-bottom: 10px;
}
#afis-app .shim-top-13 {
  margin-top: 13px;
}
#afis-app .detail-table {
  border-collapse: collapse;
  color: #333;
  font-family: "AvenirNextLTW01-regular";
  font-size: 18px;
}
#afis-app .detail-table td:not(.second-row) {
  padding-right: 35px;
}
@media (max-width: 768px) and (min-width: 481px) {
  #afis-app .detail-table td:not(.second-row) {
    padding-right: 120px;
  }
}
#afis-app .detail-table .label-row {
  color: #666;
  font-size: 12px;
}
#afis-app .detail-table .separate {
  border-left: 1px solid #ccc;
  padding-left: 25px;
  padding-right: 0;
}
#afis-app .detail-table.second {
  margin-top: 10px;
}
#afis-app .disclosure-link {
  display: block;
  font-family: "Avenir Next LT W01 Demi", Arial, sans-serif;
  font-weight: 700;
}
#afis-app .legend-item {
  color: #666;
  font-size: 12px;
  margin: 10px 10px 8px 0px;
  display: inline-block;
}
#afis-app .sub-header {
  font-family: "Avenir Next LT W01 Demi", Arial, sans-serif;
}
#afis-app .sub-header.active {
  color: #000;
}
#afis-app .sub-header sup {
  display: inline-block;
  text-decoration: none;
}
#afis-app .sub-info {
  font-size: 12px;
  font-family: "AvenirNextLTW01-Condens 721299", Arial;
  color: #666;
}
#afis-app .colored-square {
  display: inline-block;
  height: 10px;
  margin-right: 5px;
  width: 10px;
}
#afis-app .colored-circle {
  border-radius: 5px;
  display: inline-block;
  height: 10px;
  margin-right: 5px;
  width: 10px;
}
#afis-app .blue-bar {
  background-color: #f2fafd;
  display: inline-block;
  height: 21px;
  padding-left: 10px;
  white-space: nowrap;
}
#afis-app .blue-row-fill {
  background-color: #f2fafd;
}
#afis-app .blue-fill {
  background-color: #009adf;
}
#afis-app .off-blue-fill {
  background-color: #4B7BB3;
}
#afis-app .light-blue-fill {
  background-color: #66C7F2;
}
#afis-app .pale-blue-fill {
  background-color: #CCEBF9;
}
#afis-app .gray-fill {
  background-color: #666;
}
#afis-app .medium-gray-fill {
  background-color: #999;
}
#afis-app .light-gray-fill {
  background-color: #ccc;
}
#afis-app .lighter-gray-fill {
  background-color: #E4E4E4;
}
#afis-app .lightest-gray-fill {
  background-color: #F5F5F5;
}
#afis-app .yellow-fill {
  background-color: #F2B900;
}
#afis-app .light-yellow-fill {
  background-color: #F7D566;
}
#afis-app .pale-yellow-fill {
  background-color: #FCF1CC;
}
#afis-app .pale-yellow-fill {
  background-color: #FCF1CC;
}
#afis-app .aqua-fill {
  background-color: #37B8A9;
}
#afis-app .no-wrap {
  white-space: nowrap;
}
#afis-app .trademark {
  line-height: initial;
  vertical-align: super;
  font-size: 9px;
}
#afis-app .com-mod-utility-link {
  font-family: "Avenir Next LT W01 Demi", Arial, sans-serif;
  padding-right: 14px;
}
#afis-app .com-mod-utility-link i.utility {
  background-repeat: no-repeat;
  background-position: center center;
  cursor: pointer;
  display: inline-block;
  height: 16px;
  width: 16px;
  margin-right: 5px;
  vertical-align: text-bottom;
}
#afis-app table {
  margin-bottom: 20px;
  width: 100%;
}
#afis-app table .table-data {
  color: #666;
  font-size: 14px;
  font-family: "AvenirNextLTW01-Regular", Arial;
  line-height: 18px;
}
#afis-app table .com-mod-table-label,
#afis-app table .com-mod-table-data {
  color: #666;
  font-size: 14px;
  font-family: "AvenirNextLTW01-Regular", Arial;
  vertical-align: top;
  padding: 2px 8px 2px 8px;
}
#afis-app table .com-mod-table-label.strong,
#afis-app table .com-mod-table-data.strong {
  position: relative;
  z-index: 10;
}
#afis-app table th {
  font-weight: normal;
}
#afis-app table .sub-info {
  padding: 2px 8px 2px 8px;
}
#afis-app table .align-right {
  text-align: right;
}
#afis-app table .sub-table {
  margin-bottom: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,6CAA6C;AAC/C;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,sCAAsC;EACtC,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,yDAAyD;EACzD,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,yDAAyD;AAC3D;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,oDAAoD;EACpD,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,yDAAyD;EACzD,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,kCAAkC;EAClC,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;EACf,6CAA6C;EAC7C,iBAAiB;AACnB;AACA;;EAEE,WAAW;EACX,eAAe;EACf,6CAA6C;EAC7C,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;;EAEE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB","sourcesContent":["#afis-app .app {\n  margin-bottom: 35px;\n}\n#afis-app .app-title {\n  color: #333;\n  display: inline-block;\n  font-size: 18px;\n  font-weight: 500;\n  margin: 13px 0px 20px 0px;\n  font-family: \"Avenir Next LT W01 Demi\", Arial;\n}\n#afis-app a {\n  color: #1d5799;\n}\n#afis-app .shim-bottom-10 {\n  margin-bottom: 10px;\n}\n#afis-app .shim-top-13 {\n  margin-top: 13px;\n}\n#afis-app .detail-table {\n  border-collapse: collapse;\n  color: #333;\n  font-family: \"AvenirNextLTW01-regular\";\n  font-size: 18px;\n}\n#afis-app .detail-table td:not(.second-row) {\n  padding-right: 35px;\n}\n@media (max-width: 768px) and (min-width: 481px) {\n  #afis-app .detail-table td:not(.second-row) {\n    padding-right: 120px;\n  }\n}\n#afis-app .detail-table .label-row {\n  color: #666;\n  font-size: 12px;\n}\n#afis-app .detail-table .separate {\n  border-left: 1px solid #ccc;\n  padding-left: 25px;\n  padding-right: 0;\n}\n#afis-app .detail-table.second {\n  margin-top: 10px;\n}\n#afis-app .disclosure-link {\n  display: block;\n  font-family: \"Avenir Next LT W01 Demi\", Arial, sans-serif;\n  font-weight: 700;\n}\n#afis-app .legend-item {\n  color: #666;\n  font-size: 12px;\n  margin: 10px 10px 8px 0px;\n  display: inline-block;\n}\n#afis-app .sub-header {\n  font-family: \"Avenir Next LT W01 Demi\", Arial, sans-serif;\n}\n#afis-app .sub-header.active {\n  color: #000;\n}\n#afis-app .sub-header sup {\n  display: inline-block;\n  text-decoration: none;\n}\n#afis-app .sub-info {\n  font-size: 12px;\n  font-family: \"AvenirNextLTW01-Condens 721299\", Arial;\n  color: #666;\n}\n#afis-app .colored-square {\n  display: inline-block;\n  height: 10px;\n  margin-right: 5px;\n  width: 10px;\n}\n#afis-app .colored-circle {\n  border-radius: 5px;\n  display: inline-block;\n  height: 10px;\n  margin-right: 5px;\n  width: 10px;\n}\n#afis-app .blue-bar {\n  background-color: #f2fafd;\n  display: inline-block;\n  height: 21px;\n  padding-left: 10px;\n  white-space: nowrap;\n}\n#afis-app .blue-row-fill {\n  background-color: #f2fafd;\n}\n#afis-app .blue-fill {\n  background-color: #009adf;\n}\n#afis-app .off-blue-fill {\n  background-color: #4B7BB3;\n}\n#afis-app .light-blue-fill {\n  background-color: #66C7F2;\n}\n#afis-app .pale-blue-fill {\n  background-color: #CCEBF9;\n}\n#afis-app .gray-fill {\n  background-color: #666;\n}\n#afis-app .medium-gray-fill {\n  background-color: #999;\n}\n#afis-app .light-gray-fill {\n  background-color: #ccc;\n}\n#afis-app .lighter-gray-fill {\n  background-color: #E4E4E4;\n}\n#afis-app .lightest-gray-fill {\n  background-color: #F5F5F5;\n}\n#afis-app .yellow-fill {\n  background-color: #F2B900;\n}\n#afis-app .light-yellow-fill {\n  background-color: #F7D566;\n}\n#afis-app .pale-yellow-fill {\n  background-color: #FCF1CC;\n}\n#afis-app .pale-yellow-fill {\n  background-color: #FCF1CC;\n}\n#afis-app .aqua-fill {\n  background-color: #37B8A9;\n}\n#afis-app .no-wrap {\n  white-space: nowrap;\n}\n#afis-app .trademark {\n  line-height: initial;\n  vertical-align: super;\n  font-size: 9px;\n}\n#afis-app .com-mod-utility-link {\n  font-family: \"Avenir Next LT W01 Demi\", Arial, sans-serif;\n  padding-right: 14px;\n}\n#afis-app .com-mod-utility-link i.utility {\n  background-repeat: no-repeat;\n  background-position: center center;\n  cursor: pointer;\n  display: inline-block;\n  height: 16px;\n  width: 16px;\n  margin-right: 5px;\n  vertical-align: text-bottom;\n}\n#afis-app table {\n  margin-bottom: 20px;\n  width: 100%;\n}\n#afis-app table .table-data {\n  color: #666;\n  font-size: 14px;\n  font-family: \"AvenirNextLTW01-Regular\", Arial;\n  line-height: 18px;\n}\n#afis-app table .com-mod-table-label,\n#afis-app table .com-mod-table-data {\n  color: #666;\n  font-size: 14px;\n  font-family: \"AvenirNextLTW01-Regular\", Arial;\n  vertical-align: top;\n  padding: 2px 8px 2px 8px;\n}\n#afis-app table .com-mod-table-label.strong,\n#afis-app table .com-mod-table-data.strong {\n  position: relative;\n  z-index: 10;\n}\n#afis-app table th {\n  font-weight: normal;\n}\n#afis-app table .sub-info {\n  padding: 2px 8px 2px 8px;\n}\n#afis-app table .align-right {\n  text-align: right;\n}\n#afis-app table .sub-table {\n  margin-bottom: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
